import { Navigate } from 'react-router-dom';
import Loading from './Loading';
import { useActivePlugins } from '../../hooks/useActivePlugins';

interface PluginGuardProps {
  pluginKey: string;
  children: React.ReactNode;
  redirectTo?: string;
}

/**
 * Route-level guard that hides a page unless the tenant has the given plugin
 * activated. Works in combination with ModuleGuard for modules. Superadmins
 * bypass via useActivePlugins.
 */
export default function PluginGuard({ pluginKey, children, redirectTo = '/dashboard' }: PluginGuardProps) {
  const { isPluginActive, isLoading } = useActivePlugins();

  if (isLoading) return <Loading />;

  if (!isPluginActive(pluginKey)) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
}
